const CHECKOUT_ROUTES = {
  ORDER_INFORMATION: '/checkout/order-information',
  SHIPPING_ADDRESS: '/checkout/shipping-address',
  SUMMARY: '/checkout/summary',
};

export default CHECKOUT_ROUTES;
